/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
  "\\/[a-d][-\\.\\/_A-Za-z][DHWXm][-\\.\\/_A-Za-z][59FVZ][-\\.\\/_A-Za-z][6swyz][-\\.\\/_A-Za-z][-\\/_0-9a-zA-Z][-\\.\\/_A-Za-z][-\\/_0-9a-zA-Z]{22,162}$/",
  "\\/(?=[\\/a-zA-Z]*[+0-9])(?=[+\\/0-9a-z]*[A-Z])[+\\/0-9a-zA-Z]{",
  "/homad-global-configs.schneevonmorgen.com/global_config",
  "/videojs-vast-vpaid@2.0.2/bin/videojs_5.vast.vpaid.min",
  "/etc.clientlibs/logitech-common/clientlibs/onetrust.",
  "\\/(?=[a-z]{0,6}[0-9A-Z])[0-9a-zA-Z]{7}\\",
  "/pagead/managed/js/gpt/*/pubads_impl",
  "\\?aHR0c[\\/0-9a-zA-Z]{33,}=?=?$/",
  "\\.pussyspace\\.(?:com|net)\\/",
  "/pagead/js/adsbygoogle.js",
  "\\/[+\\/0-9a-zA-Z]{400,}$/",
  "/fileadmin/user_upload/",
  "/js/sdkloader/ima3_dai",
  "/js/sdkloader/ima3.js",
  "/sites/default/files/",
  "/wp-content/plugins/",
  "/wp-content/uploads/",
  "/detroitchicago/",
  "*/satellitelib-",
  "/appmeasurement",
  "/img/linklist2/",
  "/(https?:\\/\\/)",
  "/cdn-cgi/trace",
  "/^https?:\\/\\/",
  "[a-zA-Z0-9]{",
  "/^https:\\/\\/",
  "/wp-content/",
  "impression",
  "[0-9a-f]{",
  "[0-9a-z]{",
  "/template",
  "affiliate",
  "analytics",
  "collector",
  "/assets/",
  "/collect",
  "/images/",
  "tracking",
  "300x250",
  "captcha",
  "consent",
  "content",
  "counter",
  "privacy",
  "sponsor",
  "visitor",
  ".aspx?",
  "/media",
  "0-9a-z",
  "728x90",
  "banner",
  "bundle",
  "client",
  "cookie",
  "detect",
  "google",
  "metric",
  "prebid",
  "public",
  "script",
  "source",
  "widget",
  ".cgi?",
  ".com/",
  ".html",
  "/api/",
  "/file",
  "/img/",
  "/java",
  "/page",
  "/stat",
  "/uplo",
  "a-z]{",
  "block",
  "click",
  "count",
  "event",
  "frame",
  "image",
  "manag",
  "pixel",
  "popup",
  "theme",
  "track",
  "video",
  ".gif",
  ".jpg",
  ".min",
  ".php",
  ".png",
  "/jqu",
  "/js/",
  "/lib",
  "/log",
  "/web",
  "468x",
  "bung",
  "gdpr",
  "gi-b",
  "ight",
  "page",
  "play",
  "show",
  "view",
  ".js",
  "(?:",
  "}\\.",
  "/ad",
  "/js",
  "=*&",
  "com",
  "ext",
  "ive",
  "jax",
  "log",
  "lug",
  "sdk",
  "tag",
  "web",
  "*/",
  "*^",
  "/_",
  "/?",
  "/*",
  "/d",
  "/f",
  "/g",
  "/h",
  "/l",
  "/m",
  "/n",
  "/r",
  "/w",
  "\\/",
  "20",
  "a-",
  "ac",
  "ad",
  "ag",
  "al",
  "am",
  "an",
  "ap",
  "ar",
  "as",
  "at",
  "be",
  "bo",
  "ce",
  "ch",
  "co",
  "de",
  "e-",
  "e/",
  "ed",
  "el",
  "em",
  "en",
  "er",
  "et",
  "ic",
  "id",
  "ig",
  "il",
  "im",
  "in",
  "is",
  "it",
  "js",
  "la",
  "le",
  "li",
  "lo",
  "ma",
  "mp",
  "ol",
  "om",
  "on",
  "op",
  "or",
  "ot",
  "p-",
  "re",
  "ro",
  "s_",
  "s-",
  "s?",
  "s/",
  "sp",
  "ss",
  "st",
  "t/",
  "te",
  "tm",
  "tr",
  "ub",
  "um",
  "un",
  "ur",
  "us",
  "ut",
  "_",
  "-",
  ",",
  ":",
  "?",
  ".",
  ")",
  "[",
  "}",
  "*",
  "/",
  "\\",
  "&",
  "^",
  "=",
  "|",
  "$",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];